export default __webpack_public_path__ + "static/illustration-content-desc.url-dd7a16d8e48888b971da3982b73b11b0.svg";